import React from 'react'
import axios from "axios";
import { faXmarkCircle } from "@fortawesome/free-regular-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions} from "../../store";
import { CompanyActions } from "../../store/company_dtl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


const ConfirmCancel = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
	const auth_token = useSelector((state) => state.Company.auth_token);
	const orderId = useSelector((state) => state.EMenu.emenuOrderId);
    const approvedOrder = useSelector((state) => state.EMenu.approvedOrder);
	const c_url = useSelector((state) => state.Company.c_url);
	const m_id = useSelector((state) => state.Company.m_id);
    const available_table = useSelector((state) => state.Company.available_table);
    const tableid = useSelector((state) => state.Company.tableId);
    const [isClicked, setIsClicked] = React.useState(false);


    // const acceptAwaiting = useSelector((state) => state.EMenu.acceptAwaiting);

    const noCancel = () => {
        dispatch(EMenuActions.setConfirmCancel(false));
    }
    const yesProceed = async () => {
        setIsClicked(true);
        const sendApproval = {
            products: {}, // Initialize an empty object for products
            action: "cancel", // Set the action property
            orderId: orderId,
        };
        await approvedOrder.forEach((item) => {
            // console.log(item.ProductId);
            const productData = {
                Accept: "8",
            };
            const productObject = {
                [item.ProductId]: productData
            };
            // Assign the productObject to the products object
            Object.assign(sendApproval.products, productObject);  
        });
        // console.log("sned", JSON.stringify(sendApproval));
        try{
            const submitOrder = await axios.post(`https://${c_url}/api/v1/Orders/customerProcessOrder`, sendApproval, {
                headers: {
                Authorization: `${auth_token}`,
                },
            });
            if(submitOrder.status === 200 || submitOrder.status === 201){
                    toast.info("Order has been cancelled refreshing", {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                setTimeout(() => {
                    dispatch(EMenuActions.setPlaceOrder(false));
                    localStorage.removeItem("cartItems");
                    dispatch(EMenuActions.setCartItems([]));
                    dispatch(CompanyActions.setSL_TB(""));
                    navigate(`/${m_id}/menu`);
                    dispatch(EMenuActions.setAcceptAwaiting(true));
					dispatch(EMenuActions.setEmenuOrderId(""));
                    localStorage.setItem('orderId');
                    dispatch(EMenuActions.setAcceptStatus(""));
                    dispatch(EMenuActions.setHoldApproval([]));
                    dispatch(EMenuActions.clearApprovedOrder())
                }, 2000
		        );
            }
            }catch(e){
                console.error("Error submitting order:", e);
            }
    }
    return (
        <div className="bg-dark/50 overflow-hidden fixed z-50 min-h-screen top-0 left-0 right-0 bottom-0">
            <div className="relative">
        <div className="md:w-[90%] lg:w-[70%] xl:w-[50%] max-sm:w-[90%] m-auto bg-white rounded-lg md:my-2 md:pt-2 max-sm:p-1 max-sm:mt-20">
            <div
                className="flex justify-end cursor-pointer"
                onClick={noCancel}
            >
                <FontAwesomeIcon
                    icon={faXmark}
                    size="xl"
                    className=" text-light p-2 border-light border-2 rounded-lg bg-primaryLight/30 "
                />
            </div>
            <div className="flex flex-col gap-3 text-danger text-7xl h-[45vh] max-sm:h-[40vh] p-20 max-sm:p-10">
                <FontAwesomeIcon icon={faXmarkCircle} size="lg" />
                <p className="text-xl font-extrabold text-center text-dark mb-0 ">Cancel your current order?</p>
            </div>
            <div className="flex justify-center">
                <button className="p-3 bg-secondary rounded text-white mb-5" disabled={isClicked} onClick={yesProceed}>{' '}  Proceed</button>
            </div>
            </div>
            </div>
        </div>
    )
}

export default ConfirmCancel
